<div class="section">
  <h3>
    {{ 'COMMON.SUMMARY' | translate }}
    <mat-icon class="copy-icon" (click)="copyToClipboard(summary())">content_copy</mat-icon>
  </h3>
  <p>{{ summary() }}</p>
</div>

<div class="section">
  <h3>
    {{ 'COMMON.KEY_TAKEAWAYS' | translate }}
    <mat-icon class="copy-icon" (click)="copyToClipboard(keyTakeaways())">content_copy</mat-icon>
  </h3>
  <ul>
    <li *ngFor="let takeaway of keyTakeaways()">{{ takeaway }}</li>
  </ul>
</div>

<div class="section">
  <h3>
    {{ 'COMMON.ACTION_ITEMS' | translate }}
    <mat-icon class="copy-icon" (click)="copyToClipboard(actionItems())">content_copy</mat-icon>
  </h3>
  <ul>
    <li *ngFor="let item of actionItems()">{{ item }}</li>
  </ul>
</div>
